import React, { useEffect, useState } from "react";

import Event3 from "../../assets/img/events/event3.png";
import Avatar2 from "../../assets/img/avatars/2.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { RestfullApiService } from "../../config/service";
import { decryptData, encryptData } from "../../utils/storage";
import { MEDIA_URL } from "../../config/url";
import { Avatar } from "@mui/material";
import { useSelector } from "react-redux";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";

function EventReviews() {
  // const user = JSON.parse(localStorage.getItem("userProf"));
  const user = useSelector((state) => state.user.userProfile);

  const navigate = useNavigate();
  const { event_name, event_id } = useParams();

  const [reviewData, setReviewData] = useState([]);
  const [submitReview, setSubmitReview] = useState(false);
  const [reviewData1, setReviewData1] = useState([]);
  const [myReview, setMyReview] = useState([]);
  const [visibleReviews, setVisibleReviews] = useState(4);

  const decrypted = decryptData(event_id);
  const ReviewSchema = Yup.object().shape({
    comment: Yup.string().required("Comment is required"),
    rating: Yup.number()
      .min(1, "Please provide a rating")
      .required("Rating is required"),
  });
  const initialValues = {
    comment: "",
    rating: 0,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "Create",
      Event_Id: decrypted,
      ReviewDescription: values?.comment,
      Rating: values?.rating,
    };

    console.log("Submit Data:", reqdata);

    try {
      setSubmitReview(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/reviews_set"
      );
      console.log("API Response:", result);
      if (result?.data?.Table1[0]?.Result_Id === -1) {
        toast.error(result?.data?.Table1[0]?.Result_Description);
        return;
      }
      if (result) {
        toast.success("Review submitted successfully!");
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err.message || "An error occurred");
    } finally {
      setSubmitReview(false);
      getReview();
    }
  };

  const getReview = async () => {
    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id ? user?.Participant_Id : "NA",
      Session_User_Name:
        user?.First_Name || user?.Last_Name
          ? `${user?.First_Name} ${user?.Last_Name}`
          : "NA",
      Method_Name: "EventWiseGet",
      Event_Id: decrypted,
    };

    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/reviews_get"
      );
      // console.log("API Response:", result);

      if (result) {
        setReviewData(result?.data?.Table1);
        setReviewData1(result?.data?.Table2);
        setMyReview(result?.data?.Table3);
        console.log(reviewData);
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err.message || "An error occurred");
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getReview();
  }, []);

  const handleViewMore = () => {
    setVisibleReviews((prevVisibleReviews) => prevVisibleReviews + 4);
  };

  const handleRatingClick = (setFieldValue, newRating) => {
    // setRating(newRating);
    setFieldValue("rating", newRating);
  };

  return (
    <>
      <section
        style={{ marginTop: "80px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center text-14 fw-500 text-light-1 font-inter">
                <div className="col-auto">
                  <a href="/" className="cursor-pointer">
                    Home
                  </a>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={() => navigate("/event/list")}
                  >
                    Events
                  </div>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(`/event-details/${event_name}/${event_id}`)
                    }
                  >
                    Event Details
                  </div>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div className="text-primary">Event Reviews</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="layout-pt-md layout-pb-md">
        <div className="container">
          <div className="row y-gap-30">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title font-inter">
                  Recent Reviews
                </h2>
                <p className="sectionTitle__text text-reading fw-500 mt-5 sm:mt-0 text-14">
                  Honest reviews and testimonials
                </p>
              </div>
            </div>
            <div className="col-12">
              {reviewData.map((item, index) => (
                <div
                  key={index}
                  className="border-light py-20 px-20 rounded-16 -hover-shadow"
                >
                  <div className="row x-gap-20 y-gap-20 justify-start items-center">
                    <div className="col-lg-3">
                      <div className="cardImage ratio ratio-2:1 w-250 md:w-1/1 rounded-16">
                        <div className="cardImage__content">
                          <img
                            className="rounded-16 col-12"
                            // src={Event3}
                            src={`${MEDIA_URL}${item.Image_Path}`}
                            alt="event-3"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <h3 className="text-24 trim-2 font-inter lh-14 fw-600 py-5">
                        {item?.Display_Name}
                      </h3>
                      <div className="row x-gap-10 y-gap-10 items-center pt-10">
                        <div className="col-auto fw-500 d-flex items-center x-gap-5">
                          <i className="fas fa-map-marker-alt icon text-primary"></i>
                          <span className="text-15 font-inter text-reading fw-600">
                            {item?.City_Name}, {item?.State}
                          </span>
                        </div>
                        <div className="col-auto fw-600 d-flex items-center x-gap-5">
                          <i className="fas fa-running text-primary"></i>
                          <div className="text-15 lh-14 font-inter text-reading">
                            {item.EventType_Name}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="text-center lg:d-flex items-center gap-15">
                        <div className="text-11 font-inter lh-12 fw-600">
                          Total Reviews
                        </div>
                        <div className="text-22 lh-12 font-inter fw-600 mt-10 lg:mt-0">
                          {item?.Total_Rating} Reviews
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 text-right md:text-left relative">
                      <div className="text-center lg:d-flex items-center gap-15">
                        <div className="text-11 font-inter lh-12 fw-600 text-center">
                          Average Rating
                        </div>
                        <div className="text-18 lh-12 fw-600 mt-10 lg:mt-0">
                          {Array.from({ length: 5 }, (_, i) => (
                            <i
                              key={i}
                              className={`fas fa-star ${
                                i < item.Rating ? "text-green" : ""
                              }`}
                              style={
                                i >= item.Rating
                                  ? { color: "rgb(232 244 229)" }
                                  : {}
                              }
                            ></i>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="layout-pb-md">
        <div className="container">
          <div className="row">
            {[...reviewData1, ...myReview].map((list, index) => (
              <div key={index} className="col-lg-6 mb-4 py-20">
                <div className="col-auto">
                  <div className="row x-gap-20 y-gap-20">
                    <div className="col-auto">
                      <Avatar
                        className="mr-10"
                        sx={{
                          bgcolor: "#EE5636",
                          marginLeft: "10px",
                        }}
                      >
                        {list?.Created_By_Name?.slice(0, 1)}
                      </Avatar>
                    </div>
                    <div className="col-lg-10">
                      <div className="fw-600 font-inter lh-15 pb-5">
                        {list?.Created_By_Name}
                      </div>
                      {list.Rating > 0 ? (
                        <div className="text-13 text-yellow-3 lh-15">
                          {Array.from({ length: 5 }, (_, i) => (
                            <i
                              key={i}
                              className={`fa-star pr-4 ${
                                i < list.Rating
                                  ? "fas star-color"
                                  : "far fw-200"
                              }`}
                              style={
                                i >= list.Rating ? { color: "#949494" } : {}
                              }
                            ></i>
                          ))}
                        </div>
                      ) : (
                        <div
                          className="text-13 lh-15 fw-500 font-inter"
                          style={{ color: "#949494" }}
                        >
                          No Rating
                        </div>
                      )}
                      <p className="text-13 text-reading text-light-1 mt-10 fw-500 lh-13">
                        {list?.Review}
                      </p>
                      {/* <div className="d-flex x-gap-30 items-center pt-20">
                        <button className="d-flex items-center text-light-1">
                          <i className="fas fa-thumbs-up text-16 mr-10"></i>
                        </button>
                        <button className="d-flex items-center text-light-1">
                          <i className="fas fa-thumbs-down text-16 mr-10"></i>
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* <div className="row pt-30 justify-center">
            <div className="col-auto">
              <a
                onClick={handleViewMore}
                href="#"
                className="button -md text-primary underline fw-600"
              >
                View More
              </a>
            </div>
          </div> */}
          {!myReview?.length > 0 ? (
            <Formik
              initialValues={initialValues}
              validationSchema={ReviewSchema}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, setFieldValue, isSubmitting }) => (
                <Form>
                  <div className="row pt-30 justify-center">
                    <div className="col-xl-10 col-lg-10">
                      <div className="row y-gap-30 pt-20 justify-center">
                        <div className="col-auto text-center">
                          <h3 className="text-18 fw-600">
                            Share your experience with us
                          </h3>
                        </div>
                        <div className="col-12">
                          <div className="form-input d-flex flex-column gap-10">
                            <Field
                              as="textarea"
                              className={`text-14 ${
                                touched.comment && errors.comment
                                  ? "input-error"
                                  : ""
                              }`}
                              name="comment"
                              rows="4"
                              required
                            />
                            {touched.comment && errors.comment ? (
                              <div className="text-error-2 text-13">
                                {errors.comment}
                              </div>
                            ) : (
                              <></>
                            )}
                            <label className="lh-1 text-13 text-light-1">
                              Write Your Comment
                            </label>
                            {/* <ErrorMessage
                              className="text-error-2 text-13"
                              name="comment"
                              component="div"
                            /> */}
                          </div>
                        </div>
                        <div className="col-12 d-flex flex-column gap-10 items-center">
                          <div className="d-flex x-gap-10 justify-center">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <i
                                key={star}
                                className={`fa-star text-primary text-22 ${
                                  star <= values.rating ? "fas" : "far"
                                }`}
                                onClick={() =>
                                  handleRatingClick(setFieldValue, star)
                                }
                              ></i>
                            ))}
                          </div>
                          {/* {touched.rating && errors.rating && (
                            <div className="text-error-2 text-13">
                              {errors.rating}
                            </div>
                          )} */}
                          <ErrorMessage
                            className="text-error-2 text-13 text-center"
                            name="rating"
                            component="div"
                          />
                        </div>
                        <div className="col-auto relative">
                          <button
                            type="submit"
                            className="button w-150 h-40 -primary-1 border-primary text-primary rounded-25 load-button"
                            disabled={isSubmitting}
                          >
                            {!isSubmitting && "Post Comment"}
                            {isSubmitting && (
                              <span className="btn-spinner"></span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          ) : (
            <></>
          )}
        </div>
      </section>
      {/* <section className="layout-pb-md">
        <div className="container">
          <div className="row y-gap-30">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title">Other Events Reviews</h2>
              </div>
            </div>
            <div className="col-12">
              <div className="border-light py-20 px-20 rounded-16 -hover-shadow">
                <div className="row x-gap-20 y-gap-20 justify-between items-center">
                  <div className="col-md-auto">
                    <div className="cardImage ratio ratio-2:1 w-250 md:w-1/1 rounded-16">
                      <div className="cardImage__content">
                        <img
                          className="rounded-16 col-12"
                          src={Event3}
                          alt="event-3"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-auto">
                    <h3 className="text-18 trim-2 lh-14 fw-600">
                      Endurance Quest Marathon Organizes By HEO
                    </h3>
                    <div className="row x-gap-10 y-gap-10 items-center pt-10">
                      <div className="col-auto fw-500 d-flex items-center x-gap-5">
                        <i className="fas fa-map-marker-alt icon text-primary"></i>
                        <span className="text-14">
                          Mumbai Maharashtra, India
                        </span>
                      </div>
                      <div className="col-auto fw-500 d-flex items-center x-gap-5">
                        <i className="fas fa-running text-primary"></i>
                        <div className="text-14 lh-14">Running</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-auto">
                    <div className="">
                      <div className="text-10 lh-12 fw-600 text-center">
                        Total Reviews
                      </div>
                      <div className="text-18 lh-12 fw-600 mt-10">
                        500 Reviews
                      </div>
                    </div>
                  </div>
                  <div className="col-md-auto text-right md:text-left relative">
                    <div className="">
                      <div className="text-10 lh-12 fw-600 text-center">
                        Average Rating
                      </div>
                      <div className="text-18 lh-12 fw-600 mt-10">
                        <i className="fas fa-star text-green"></i>
                        <i className="fas fa-star text-green"></i>
                        <i className="fas fa-star text-green"></i>
                        <i className="fas fa-star text-green"></i>
                        <i className="fas fa-star text-green"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default EventReviews;
